export let hrms41eColumns = () => {
  let indexColumns = [{
    key: 'dteappoi',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numtmapp',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'numappl',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '70',
    style: 'min-width: 100px;',
    class: 'align-center',
    eventName: 'numappl'
  }, {
    key: 'desc_numappl',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codposrq',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '90',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_stapphinv',
    name: '',
    labelCodapp: 'HRMS41EC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;'
  }]

  let detailTab2Columns = [{
    key: 'numreqrq',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codposrq',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '50',
    style: 'min-width: 120px;'
  }, {
    key: 'dteappoi',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }, {
    key: 'desc_stapphinv',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRMS41EC3',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }]

  return {
    en: {
      index: indexColumns,
      detailTab2: detailTab2Columns
    },
    th: {
      index: indexColumns,
      detailTab2: detailTab2Columns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms41e.js